'use strict';

function ctrl($scope, $http, $location, $window) {
    let model = this;
    var tries = 0, maxtries = 3;
    model.login = function () {
        if (typeof model.user === 'undefined') { return }
        if (model.user.twoStepCode) {
            //Validate if code is number
            if(isNaN(model.user.twoStepCode)) { model.loginerror= "Code is not a number." ; return; }
            model.loginerror = false;
            $http.post(api+'/auth/2factor/verify', model.user)
                .success(function (user) {
                    // assign new token (by replacing old one)
                    $window.sessionStorage.token = user.token;
                    $location.url('/live');
                })
                .error(function () {
                    tries++;
                    if (tries === maxtries) {
                        delete $window.sessionStorage.token;
                        $location.url('/login');
                    } else {
                        model.loginerror = "Wrong passcode, please try again";
                    }
                });
        }
    };
}

ctrl.$inject = ['$scope', '$http', '$location', '$window'];
module.exports = ctrl;


/** WEBPACK FOOTER **
 ** ./src/auth/controllers/twostep.js
 **/